// mailer.js — E-Mail-Versand über die Edge Function "send-mail" (Mailjet).
//
// Demo/Sandbox: Versand wird simuliert (kein Serverkontakt, keine Mail).
// LIVE: JWT-geschützter Aufruf; Mailjet-Keys bleiben serverseitig.
import { supabase } from "./supabase";
import { serverActive } from "./mode";
import { getPraxis } from "./settingsStore";
import { loadPatientsCache } from "./patientStore";

// messages: [{ to, toName, subject, text, replyTo?, replyToName? }] — max. 50
export async function sendMails(messages) {
  if (!serverActive()) return { ok: true, sent: messages.length, simulated: true };
  const fromName = getPraxis().name || "dida";
  const replyTo = (getPraxis().email || "").trim(); // Antworten an die Praxis statt an den Versand-Absender
  const { data, error } = await supabase.functions.invoke("send-mail", {
    body: { messages: messages.map(m => ({ ...m, fromName, ...(replyTo && !m.replyTo ? { replyTo, replyToName: getPraxis().name || "" } : {}) })) },
  });
  if (error) {
    let msg = "";
    try { const b = await error.context?.json?.(); msg = b?.error || ""; } catch {}
    throw new Error(msg || error.message || "send-mail nicht erreichbar — ist die Function deployt?");
  }
  if (data?.error) throw new Error(data.error);
  return data;
}

// Patienten-E-Mail über den Namen finden ("Nachname, Vorname" oder "Vorname Nachname")
export const findPatientEmail = (name) => {
  const norm = (s) => String(s || "").toLowerCase().replace(/\s+/g, " ").trim();
  const n = norm(name);
  const hit = loadPatientsCache().find(p =>
    norm(`${p.nachname}, ${p.vorname}`) === n || norm(`${p.vorname} ${p.nachname}`) === n);
  return (hit?.email || "").trim();
};

export const praxisAbsender = () => getPraxis().name || "Ihr Praxisteam";
